import { join } from 'light-component';
import { Box } from '../../../box';
import { Highlighter } from '../../component';
import styles from '../style.module.less';
import { Signature } from './signature';
import type { ShotEyesSignatureProps } from './types';

export function ShotEyesSignatureViewMode(props: ShotEyesSignatureProps): React.ReactElement {
  return (
    <Box className={styles.viewBox}>
      <Box className={join(styles.subject, styles.input)}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.content, styles.inputContent)}>
        <Box className={styles.canvasContainer}>
          <Signature {...props} height={200} />
        </Box>
      </Box>
    </Box>
  );
}
